import register from 'ShopUiBundle/modules/app/registry';
import './product-newsletter.scss';

// tslint:disable-next-line
register('product-newsletter', () => import(/* webpackMode: "lazy" */'./product-newsletter'));
